import { defineMessages } from 'react-intl';

const messages = defineMessages({
  seoTitle: {
    id: 'landingPage.seoTitle',
    defaultMessage: 'Welcome',
  },
  reInventCustomHelp: {
    id: 'landingPage.reInventCustomHelp',
    defaultMessage: 'Ask an AWS employee in the room for assistance',
  },
});

export default messages;
